import stringNaturalCompare from 'string-natural-compare';
import { stringForCompare as string } from './string-for-compare';

export const naturalCompare = (a, b) => {
  const aType = typeof a;
  const bType = typeof b;
  const sortType = aType === bType && bType;
  if (sortType === 'number') return a - b;
  return stringNaturalCompare(string(a), string(b));
};
